import React from 'react';
interface KreditaLogoProps {
  className?: string;
  variant?: 'full' | 'icon';
}
const KreditaLogo: React.FC<KreditaLogoProps> = ({
  className = '',
  variant = 'full'
}) => {
  if (variant === 'icon') {
    return <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-165">
        {/* Abstract K that forms a house shape */}
        <path d="M8 32V8L20 2L32 8V18L20 24L8 18V32Z" fill="currentColor" opacity="0.1" data-id="element-166" />
        <path d="M8 8L20 2L32 8M8 18L20 12L32 18M20 12V24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-167" />
        <path d="M8 18L20 24L32 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-168" />
      </svg>;
  }
  return <div className={`flex items-center ${className}`} data-id="element-169">
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" data-id="element-170">
        <path d="M8 32V8L20 2L32 8V18L20 24L8 18V32Z" fill="currentColor" opacity="0.1" data-id="element-171" />
        <path d="M8 8L20 2L32 8M8 18L20 12L32 18M20 12V24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-172" />
        <path d="M8 18L20 24L32 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-173" />
      </svg>
      <span className="ml-3 text-2xl font-bold tracking-tight" data-id="element-174">Kredita</span>
    </div>;
};
export default KreditaLogo;